import React from 'react';
import TeamMemberForm from './TeamMemberForm';
import Button from '../common/Button';
import { defaultTeamMember } from '../../utils/constants';

function TeamMemberList({ teamMembers, onChange }) {
  const handleMemberChange = (index, updatedMember) => {
    const newTeamMembers = [...teamMembers];
    newTeamMembers[index] = updatedMember;
    onChange(newTeamMembers);
  };

  const handleAddMember = () => {
    onChange([...teamMembers, { ...defaultTeamMember }]);
  };

  const handleRemoveMember = (index) => {
    const newTeamMembers = teamMembers.filter((_, i) => i !== index);
    onChange(newTeamMembers);
  };

  return (
    <div>
      {teamMembers.map((member, index) => (
        <TeamMemberForm
          key={index}
          member={member}
          index={index}
          onChange={handleMemberChange}
          onRemove={handleRemoveMember}
        />
      ))}

      <Button
        variant="secondary"
        onClick={handleAddMember}
        className="w-full"
      >
        + Add Team Member
      </Button>
    </div>
  );
}

export default TeamMemberList;
